import React from "react";


export const AnimatedRobot = ({
  width = 201,
  height = 200,
  className = "",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 201 200"
      fill="none"
      className={`robot-svg ${className}`}
    >
      {/* Main body with hover effect */}
      <path
        className="robot-body"
        d="M197.167 30V126.667C197.167 132.2 192.7 136.667 187.167 136.667H67.1667C61.6333 136.667 57.1667 132.2 57.1667 126.667V30L60.5 26.6666H193.833L197.167 30Z"
        fill="#DCE4EA"
      />

      {/* Header */}
      <path
        className="robot-header"
        d="M197.167 13.3334V30H57.1667V13.3334C57.1667 7.80004 61.6333 3.33337 67.1667 3.33337H187.167C192.7 3.33337 197.167 7.80004 197.167 13.3334Z"
        fill="#5E0A45"
      />

      {/* Chat bubbles with pulse animation */}
      <path
        className="chat-bubble-1"
        d="M157.167 56.6666C157.167 59.4333 156.033 61.9333 154.233 63.7333C152.433 65.5333 149.933 66.6666 147.167 66.6666H107.167L96.2667 73.2C93.7333 74.7333 90.5 72.9 90.5 69.9333V66.6666H83.8333C78.3 66.6666 73.8333 62.2 73.8333 56.6666C73.8333 53.9 74.9667 51.4 76.7667 49.6C78.5667 47.8 81.0667 46.6666 83.8333 46.6666H147.167C152.7 46.6666 157.167 51.1333 157.167 56.6666Z"
        fill="#582AA8"
      />

      <path
        className="chat-bubble-2"
        d="M97.1667 100C97.1667 102.767 98.3 105.267 100.1 107.067C101.9 108.867 104.4 110 107.167 110H147.167L158.067 116.533C160.6 118.067 163.833 116.233 163.833 113.267V110H170.5C176.033 110 180.5 105.533 180.5 100C180.5 97.2333 179.367 94.7333 177.567 92.9333C175.767 91.1333 173.267 90 170.5 90H107.167C101.633 90 97.1667 94.4667 97.1667 100Z"
        fill="#6D24FE"
      />

      {/* Robot face parts with animations */}
      <path
        className="robot-face"
        d="M43.8333 73.3334H50.5C67.0566 73.3334 80.5 86.7767 80.5 103.333V106.667C80.5 114.027 74.5266 120 67.1666 120H27.1666C19.8066 120 13.8333 114.027 13.8333 106.667V103.333C13.8333 86.7767 27.2766 73.3334 43.8333 73.3334Z"
        fill="#5E0A45"
      />

      {/* Eyes with blink animation */}
      <path
        className="eye left-eye"
        d="M33.8333 103.333C31.9933 103.333 30.5 101.843 30.5 100V93.3333C30.5 91.49 31.9933 90 33.8333 90C35.6733 90 37.1667 91.49 37.1667 93.3333V100C37.1667 101.843 35.6733 103.333 33.8333 103.333Z"
        fill="white"
      />

      <path
        className="eye right-eye"
        d="M60.5 103.333C58.66 103.333 57.1667 101.843 57.1667 100V93.3333C57.1667 91.49 58.66 90 60.5 90C62.34 90 63.8333 91.49 63.8333 93.3333V100C63.8333 101.843 62.34 103.333 60.5 103.333Z"
        fill="white"
      />

      {/* Mouth with smile animation */}
      <path
        className="mouth"
        d="M50.5 110H43.8333C41.9933 110 40.5 108.51 40.5 106.667C40.5 104.823 41.9933 103.333 43.8333 103.333H50.5C52.34 103.333 53.8333 104.823 53.8333 106.667C53.8333 108.51 52.34 110 50.5 110Z"
        fill="white"
      />

      {/* Rest of the robot parts */}
      <path
        d="M74.6 136.667H77.1666C84.5333 136.667 90.5 142.633 90.5 150V156.667C90.5 165.9 84.2 173.7 75.6666 175.967L74.6 136.667Z"
        fill="#97A7AF"
      />
      <path
        d="M18.6666 175.967C10.1333 173.7 3.83331 165.9 3.83331 156.667V150C3.83331 142.633 9.79998 136.667 17.1666 136.667H19.7333L18.6666 175.967Z"
        fill="#97A7AF"
      />
      <path d="M30.5 116.667H63.8333V136.667H30.5V116.667Z" fill="#97A7AF" />
      <path
        className="robot-body-bottom"
        d="M77.1667 156.667V166.667C77.1667 183.233 63.7333 196.667 47.1667 196.667C30.6 196.667 17.1667 183.233 17.1667 166.667V156.667L20.5 153.333H73.8333L77.1667 156.667Z"
        fill="#BCC7CE"
      />
    </svg>
  );
};
